import { createRouter, createWebHistory } from "vue-router";
import Home from '@/pages/Home.vue'
import Region from '@/pages/Region.vue'
import NotFound from '@/pages/NotFound.vue'

const routes = [
    { path: '/', name: 'home', component: Home },
    { path: '/regions/:regionCode', name: 'region', component: Region },
    { path: '/:pathMatch(.*)*', name: 'not-found', component: NotFound },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(_to, _from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        }
        return { top: 0, behavior: 'smooth' }
    },
})

export default router